export interface GeoPosition {
    latitude: number
    longitude: number
    mapUrl: string
}

export function googleMapsUrl(latitude: number, longitude: number): string {
    return `https://www.google.com/maps?q=${latitude.toFixed(6)},${longitude.toFixed(6)}`
}

export function getGeolocationErrorMessage(error: GeolocationPositionError): string {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            return 'Location permission was denied. Allow location access and try again.'
        case error.POSITION_UNAVAILABLE:
            return 'Location information is unavailable.'
        case error.TIMEOUT:
            return 'Location request timed out. Try again.'
        default:
            return 'Unable to get your current location.'
    }
}

export function getCurrentPosition(): Promise<GeoPosition> {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error('Location is not supported in this browser.'))
            return
        }

        navigator.geolocation.getCurrentPosition(
            position => {
                const latitude = position.coords.latitude
                const longitude = position.coords.longitude
                resolve({
                    latitude,
                    longitude,
                    mapUrl: googleMapsUrl(latitude, longitude),
                })
            },
            error => reject(new Error(getGeolocationErrorMessage(error))),
            {
                enableHighAccuracy: true,
                timeout: 15000,
                maximumAge: 0,
            },
        )
    })
}
